import actions from "./actions";

const {
    FETCH_APPOINTMENTS,
    RESET_APPOINTMENTS,
} = actions;

const initState = {
    getAppointments: {
        page: 0,
        perPage: 35,
        data: [],
        total: 0
    },
};

const GetAppointmentsReducer = (state = initState, action) => {
    const { type, data } = action;

    switch (type) {

        case FETCH_APPOINTMENTS:
            return {
                ...state,
                getAppointments: data
            };

        case RESET_APPOINTMENTS:
            return {
                ...state,
                getAppointments: initState.getAppointments
            };

        default:
            return state;
    }
};

export default GetAppointmentsReducer;
